'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ENABLE_CONTINUE_PLAYING_UPDATED = 'enable-continue-playing:updated';
var ENABLE_CONTINUE_PLAYING_QUERY = 'enable-continue-playing:query';
var NET_POSITION_BAR_UPDATED = 'net-position-bar:updated';
var NET_POSITION_AMOUNT_UPDATED = 'net-position-amount:updated';
var GAME_SESSION_UPDATED = 'game-session:updated';
var GAME_CLICKED = 'game:clicked';
var GAMEPLAY_SIDENAV_QUERY = 'gameplay-sidenav:query';
var GAMEPLAY_SIDENAV_UPDATED = 'gameplay-sidenav:updated';
var GAMEPLAY_BLOCK_LAUNCH_UPDATED = 'gameplay-block-launch:updated';
var GAMEPLAY_BLOCK_LAUNCH_QUERY = 'gameplay-block-launch:query';

exports.ENABLE_CONTINUE_PLAYING_QUERY = ENABLE_CONTINUE_PLAYING_QUERY;
exports.ENABLE_CONTINUE_PLAYING_UPDATED = ENABLE_CONTINUE_PLAYING_UPDATED;
exports.GAMEPLAY_BLOCK_LAUNCH_QUERY = GAMEPLAY_BLOCK_LAUNCH_QUERY;
exports.GAMEPLAY_BLOCK_LAUNCH_UPDATED = GAMEPLAY_BLOCK_LAUNCH_UPDATED;
exports.GAMEPLAY_SIDENAV_QUERY = GAMEPLAY_SIDENAV_QUERY;
exports.GAMEPLAY_SIDENAV_UPDATED = GAMEPLAY_SIDENAV_UPDATED;
exports.GAME_CLICKED = GAME_CLICKED;
exports.GAME_SESSION_UPDATED = GAME_SESSION_UPDATED;
exports.NET_POSITION_AMOUNT_UPDATED = NET_POSITION_AMOUNT_UPDATED;
exports.NET_POSITION_BAR_UPDATED = NET_POSITION_BAR_UPDATED;
